var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { API_URL, V2_API_URL } from '@settings';
import CryptoJS from "crypto-js";
export const apiClient = axios.create({
    baseURL: `${API_URL}/`,
    timeout: 500000,
});
// Schedule API
export function setupNewBoat(data, accessToken) {
    return fetch(`${V2_API_URL}/boat/setup`, {
        method: 'POST',
        body: JSON.stringify({ data }),
        headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
        },
    });
}
export function bookBoat(data, accessToken) {
    // Ensure rental_id is provided or generate one
    const rentalId = data.rental_id || `${new Date().getTime()}-${data.boat_id}`;
    const nextSteps = data.next_steps || [];
    return fetch(`${API_URL}/api/schedule/book`, {
        method: 'POST',
        body: JSON.stringify({
            data: {
                boat_id: data.boat_id,
                start_time: data.start_time,
                end_time: data.end_time,
                booking_type: data.booking_type,
                renter_id: data.renter_id,
                rental_id: rentalId,
                next_steps: nextSteps,
                Details: data.Details || {},
            }
        }),
        headers: { Authorization: `Bearer ${accessToken}` },
    });
}
export function patchBookingStatus(rentalId, newStatus, accessToken) {
    return fetch(`${V2_API_URL}/transaction/book`, {
        method: 'PATCH',
        body: JSON.stringify({
            data: {
                "RentalID": rentalId,
                "BookingInfo.Status": newStatus,
            },
        }),
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    });
}
export function patchBooking(rentalId, data, accessToken) {
    return fetch(`${V2_API_URL}/transaction/book`, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
            data: Object.assign({ "RentalID": rentalId }, data),
        }),
    });
}
export function deleteBooking(data) {
    return fetch(`${API_URL}/api/schedule/book`, {
        method: 'DELETE',
        body: JSON.stringify({ data }), // Ensure rental_id is sent correctly
        headers: { Authorization: `Bearer ${data.token}` },
    });
}
export function deleteBoat(data, accessToken) {
    return fetch(`${V2_API_URL}/boat/delete/${data.boat_id}`, {
        method: 'DELETE',
        body: JSON.stringify({ data }),
        headers: { Authorization: `Bearer ${accessToken}` },
    });
}
export function getBoatSchedule(boatId, accessToken, extend, dates, page, limit) {
    const params = new URLSearchParams({
        boat_id: boatId,
        extend: String(extend || false),
        dates_only: String(dates || false),
    });
    if (page !== undefined) {
        params.append('page', page.toString());
    }
    if (limit !== undefined) {
        params.append('limit', limit.toString());
    }
    return fetch(`${V2_API_URL}/schedule/schedule?${params.toString()}`, {
        method: 'GET',
        headers: { Authorization: `Bearer ${accessToken}` },
    });
}
export function getRentalDetails(rentalId, accessToken) {
    return fetch(`${V2_API_URL}/transaction/rentals/${rentalId}`, {
        method: 'GET',
        headers: { Authorization: `Bearer ${accessToken}` },
    });
}
export function getAIResponse(data, accessToken) {
    return fetch(`${V2_API_URL}/ai`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`
        },
    });
}
export function searchBoatsByLocation(locationIds, accessToken) {
    const params = new URLSearchParams({ location_ids: JSON.stringify(locationIds) }).toString();
    return fetch(`${V2_API_URL}/schedule/location?${params}`, {
        method: 'GET',
        headers: { Authorization: `Bearer ${accessToken}` },
    });
}
export function searchBoatsByCustomer(customerId, accessToken) {
    return fetch(`${V2_API_URL}/boat/customer?customer_id=${customerId}`, {
        method: 'GET',
        headers: { Authorization: `Bearer ${accessToken}` },
    });
}
// Pricing API
export function addAndModifyBoatPricing(data, accessToken) {
    return fetch(`${V2_API_URL}/boat-pricing`, {
        method: 'POST',
        body: JSON.stringify({ data }),
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`
        },
    });
}
export function getBoatPricing(boatId, accessToken) {
    return fetch(`${V2_API_URL}/boat-pricing?BoatID=${boatId}`, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
        },
    });
}
export function getUser(accessToken) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield fetch(`${API_URL}/api/user`, {
                method: 'GET',
                headers: { Authorization: `Bearer ${accessToken}` },
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = yield response.json();
            return data;
        }
        catch (error) {
            console.error('Error fetching user data:', error);
            throw error;
        }
    });
}
export function patchUser(accessToken, user) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield fetch(`${API_URL}/api/user`, {
                method: 'PATCH',
                headers: { Authorization: `Bearer ${accessToken}` },
                body: JSON.stringify(user),
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = yield response.json();
            return data;
        }
        catch (error) {
            console.error('Error fetching user data:', error);
            throw error;
        }
    });
}
// Location Data
export function getLocationData(accessToken, boatId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            // Construct the URL conditionally based on whether boatId is provided
            let url = `${API_URL}/api/location`;
            if (boatId) {
                url += `?boatId=${boatId}`;
            }
            const response = yield fetch(url, {
                method: 'GET',
                headers: { Authorization: `Bearer ${accessToken}` },
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = yield response.json();
            return data;
        }
        catch (error) {
            console.error('Error fetching location data:', error);
            throw error;
        }
    });
}
export function getLocationPermission(accessToken) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield fetch(`${API_URL}/api/user`, {
                method: 'GET',
                headers: { Authorization: `Bearer ${accessToken}` },
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = yield response.json();
            let locations = [];
            if (data.userRole === 'Admin') {
                yield getLocationData(accessToken).then((data) => {
                    locations = data || [];
                });
            }
            else {
                locations = data.locations || [];
            }
            return locations;
        }
        catch (error) {
            console.error('Error fetching user data:', error);
            throw error;
        }
    });
}
export function createLocation(_a) {
    return __awaiter(this, arguments, void 0, function* ({ accessToken, data, }) {
        try {
            const response = yield fetch(`${API_URL}/api/location`, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: { Authorization: `Bearer ${accessToken}` },
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return yield response.json();
        }
        catch (error) {
            console.error('Error fetching location data:', error);
            throw error;
        }
    });
}
export function patchLocation(_a) {
    return __awaiter(this, arguments, void 0, function* ({ accessToken, data, }) {
        try {
            const response = yield fetch(`${API_URL}/api/location`, {
                method: 'PATCH',
                body: JSON.stringify(data),
                headers: { Authorization: `Bearer ${accessToken}` },
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return yield response.json();
        }
        catch (error) {
            console.error('Error fetching location data:', error);
            throw error;
        }
    });
}
export function deleteLocation(_a) {
    return __awaiter(this, arguments, void 0, function* ({ accessToken, data, }) {
        try {
            const response = yield fetch(`${API_URL}/api/location`, {
                method: 'DELETE',
                body: JSON.stringify(data),
                headers: { Authorization: `Bearer ${accessToken}` },
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return yield response.json();
        }
        catch (error) {
            console.error('Error fetching location data:', error);
            throw error;
        }
    });
}
export function getCustomer(accessToken) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield fetch(`${API_URL}/api/customer`, {
                method: 'GET',
                headers: { Authorization: `Bearer ${accessToken}` },
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = yield response.json();
            return data;
        }
        catch (error) {
            console.error('Error fetching location data:', error);
            throw error;
        }
    });
}
export function createCustomer(_a) {
    return __awaiter(this, arguments, void 0, function* ({ accessToken, data, }) {
        try {
            const response = yield fetch(`${API_URL}/api/customer`, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: { Authorization: `Bearer ${accessToken}` },
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return yield response.json();
        }
        catch (error) {
            console.error('Error fetching location data:', error);
            throw error;
        }
    });
}
export function patchCustomer(_a) {
    return __awaiter(this, arguments, void 0, function* ({ accessToken, data, }) {
        try {
            const response = yield fetch(`${API_URL}/api/customer`, {
                method: 'PATCH',
                body: JSON.stringify(data),
                headers: { Authorization: `Bearer ${accessToken}` },
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return yield response.json();
        }
        catch (error) {
            console.error('Error fetching location data:', error);
            throw error;
        }
    });
}
export function addPendingWaiver(data, accessToken) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield fetch(`${V2_API_URL}/pending-renters`, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        }
        catch (error) {
            console.error('Error adding pending waiver:', error);
            throw error;
        }
    });
}
export function getPendingRenters(transactionId, accessToken) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield fetch(`${V2_API_URL}/pending-renters?transactionId=${transactionId}`, {
                method: 'GET',
                headers: { Authorization: `Bearer ${accessToken}` },
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        }
        catch (error) {
            console.error('Error fetching pending waivers:', error);
            throw error;
        }
    });
}
// Promo/Gift Card API
export function getPromoGiftCard(params) {
    return __awaiter(this, void 0, void 0, function* () {
        const queryParams = new URLSearchParams(params).toString();
        try {
            const response = yield fetch(`${API_URL}/api/promoCode?${queryParams}`, {
                method: 'GET',
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return yield response.json();
        }
        catch (error) {
            console.error('Error fetching promo/gift card data:', error);
            throw error;
        }
    });
}
export function createPromoGiftCard(data, accessToken) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield fetch(`${API_URL}/api/promoCode`, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return yield response.json();
        }
        catch (error) {
            console.error('Error creating promo/gift card:', error);
            throw error;
        }
    });
}
export function patchPromoGiftCard(data, accessToken) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield fetch(`${API_URL}/api/promoCode`, {
                method: 'PATCH',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return yield response.json();
        }
        catch (error) {
            console.error('Error updating promo/gift card:', error);
            throw error;
        }
    });
}
export function deletePromoGiftCard(data, accessToken) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield fetch(`${API_URL}/api/promoCode?PromoCode=${data.PromoCode}`, {
                method: 'DELETE',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return yield response.json();
        }
        catch (error) {
            console.error('Error deleting promo/gift card:', error);
            throw error;
        }
    });
}
// Boat Records API
export function createBoatRecord(data, accessToken) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield fetch(`${API_URL}/api/boatRecords`, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return yield response.json();
        }
        catch (error) {
            console.error('Error creating boat record:', error);
            throw error;
        }
    });
}
export function getBoatRecords(params, accessToken) {
    return __awaiter(this, void 0, void 0, function* () {
        const queryParams = new URLSearchParams(params).toString();
        try {
            const response = yield fetch(`${API_URL}/api/boatRecords?${queryParams}`, {
                method: 'GET',
                headers: { Authorization: `Bearer ${accessToken}` },
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return yield response.json();
        }
        catch (error) {
            console.error('Error fetching boat records:', error);
            throw error;
        }
    });
}
export function updateBoatRecord(data, accessToken) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield fetch(`${API_URL}/api/boatRecords`, {
                method: 'PATCH',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return yield response.json();
        }
        catch (error) {
            console.error('Error updating boat record:', error);
            throw error;
        }
    });
}
export function deleteBoatRecord(data, accessToken) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield fetch(`${API_URL}/api/boatRecords`, {
                method: 'DELETE',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return yield response.json();
        }
        catch (error) {
            console.error('Error deleting boat record:', error);
            throw error;
        }
    });
}
export function createWebsite(data, accessToken) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield fetch(`${API_URL}/api/websiteManager`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${accessToken}`,
                },
                body: JSON.stringify(data),
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            // Check if the response has a valid JSON content type
            const contentType = response.headers.get('content-type');
            if (contentType && contentType.includes('application/json')) {
                return yield response.json(); // Return JSON if content-type is correct
            }
            else {
                throw new Error('Received non-JSON response');
            }
        }
        catch (error) {
            console.error('Error creating website:', error);
            throw error;
        }
    });
}
export function updateWebsiteTemplate(dns, data, accessToken) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield fetch(`${API_URL}/api/websiteManager`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${accessToken}`,
                },
                body: JSON.stringify({ dns, data }),
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return yield response.json();
        }
        catch (error) {
            console.error('Error updating website template:', error);
            throw error;
        }
    });
}
export function getConnectId(BoatId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield fetch(`${API_URL}/api/checkout/getConnectId?boatId=${BoatId}`, {
                method: 'GET',
            });
            // No need for auth as this is for public use
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return yield response.json();
        }
        catch (error) {
            console.error('Error fetching boat records:', error);
            throw error;
        }
    });
}
export function checkUserAvailability(userId, locationId, startUtc, endUtc, accessToken, excludeRentalId) {
    return __awaiter(this, void 0, void 0, function* () {
        const params = new URLSearchParams({
            userId,
            locationId,
            startUtc: String(startUtc),
            endUtc: String(endUtc),
        });
        if (excludeRentalId) {
            params.append('excludeRentalId', excludeRentalId);
        }
        const resp = yield fetch(`${V2_API_URL}/transaction/check-user-availability?${params.toString()}`, {
            method: 'GET',
            headers: { Authorization: `Bearer ${accessToken}` },
        });
        if (!resp.ok) {
            throw new Error(`Failed to check user availability: ${resp.statusText}`);
        }
        return yield resp.json(); // should have { available: boolean }
    });
}
// User management
export function getUsersUnderCustomer(customerId, accessToken) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield fetch(`${API_URL}/api/userManagement?customerId=${customerId}`, {
                method: 'GET',
                headers: { Authorization: `Bearer ${accessToken}` },
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return yield response.json();
        }
        catch (error) {
            console.error('Error fetching users under customer:', error);
            throw error;
        }
    });
}
// Function to create a user under a specific customerId
export function createUserUnderCustomer(email, customerId, name, role, permissions, locations, accessToken, userSkills) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const requestBody = {
                email,
                customerId,
                name,
                role,
                permissions,
                locations,
                userSkills,
            };
            const response = yield fetch(`${API_URL}/api/userManagement`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestBody),
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = yield response.json();
            return data;
        }
        catch (error) {
            console.error('Error creating user under customer:', error);
            throw error;
        }
    });
}
export function patchUserUnderCustomer(id, accessToken, email, customerId, name, role, locations, permissions, userViewSettings, userSkills) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const requestBody = {
                id,
                email,
                customerId,
                name,
                role,
                permissions,
                locations,
                userViewSettings,
                userSkills,
            };
            const response = yield fetch(`${API_URL}/api/userManagement`, {
                method: 'PATCH',
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestBody),
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = yield response.json();
            return data;
        }
        catch (error) {
            console.error('Error creating user under customer:', error);
            throw error;
        }
    });
}
export function deleteUserUnderCustomer(userId, accessToken) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield fetch(`${API_URL}/api/userManagement`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ id: userId }),
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.status === 204 ? { message: 'User deleted successfully' } : yield response.json();
        }
        catch (error) {
            console.error('Error deleting user under customer:', error);
            throw error;
        }
    });
}
export function getEventsByTransaction(transactionid, accessToken) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield fetch(`${API_URL}/api/events?transactionid=${transactionid}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return yield response.json();
        }
        catch (error) {
            console.error('Error retrieving events:', error);
            throw error;
        }
    });
}
export function addEvent(eventData) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield fetch(`${API_URL}/api/events`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${API_URL}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(eventData),
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return yield response.json();
        }
        catch (error) {
            console.error('Error adding event:', error);
            throw error;
        }
    });
}
// AES and HMAC keys should be the same as used in encryption
const encryptionKey = CryptoJS.enc.Base64.parse('XvW1aVO6N5hVniA9VvO7zV6qV3pni6jk7uSGb78RWfg=');
const hmacKey = CryptoJS.enc.Base64.parse('LsleyjnaYMuF/dHO3NI103fv85aLU80eBNmqkybko5g=');
export function publicSearchBoats(customerId, boatId, startDate, endDate) {
    return __awaiter(this, void 0, void 0, function* () {
        const url = new URL(`${V2_API_URL}/public/customer`);
        url.searchParams.append('customer_id', customerId);
        if (startDate) {
            url.searchParams.append('start_date', startDate);
        }
        if (endDate) {
            url.searchParams.append('end_date', endDate);
        }
        if (boatId) {
            url.searchParams.append('boat_id', boatId);
        }
        const response = yield fetch(url.toString(), {
            method: 'GET',
        });
        if (!response.ok) {
            throw new Error('Failed to fetch boats');
        }
        const encryptedData = yield response.text();
        const encryptedBytes = CryptoJS.enc.Base64.parse(encryptedData);
        // Extract IV, HMAC, and ciphertext
        const iv = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(0, 4)); // 16 bytes IV
        const hmac = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(4, 12)); // 32 bytes HMAC
        const ciphertext = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(12)); // Remaining ciphertext
        // Recalculate HMAC for integrity verification
        const recalculatedHmac = CryptoJS.HmacSHA256(iv.concat(ciphertext), hmacKey);
        if (CryptoJS.enc.Hex.stringify(recalculatedHmac) !== CryptoJS.enc.Hex.stringify(hmac)) {
            throw new Error('Integrity check failed: HMAC does not match');
        }
        // Decrypt using AES-CBC
        const decryptedBytes = CryptoJS.AES.decrypt({ ciphertext: ciphertext }, encryptionKey, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
        const decryptedData = CryptoJS.enc.Utf8.stringify(decryptedBytes);
        return JSON.parse(decryptedData);
    });
}
// Create a new renter
export const createRenter = (renter, accessToken) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield axios.post(`${V2_API_URL}/renters`, renter, {
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
        },
    });
    return response.data;
});
export const checkBoatAvailability = (boatId, assetId, startDate, endDate, excludeRentalId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield axios.get(`${V2_API_URL}/transaction/check-availability`, {
        params: {
            boatId,
            assetId,
            startUtc: startDate,
            endUtc: endDate,
            excludeRentalId,
        },
    });
    return response.data;
});
// Get a renter by ID
export const getRenter = (id, accessToken) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield axios.get(`${V2_API_URL}/renters/${id}`, {
        headers: {
            'Authorization': `Bearer ${accessToken}`
        }
    });
    return response.data;
});
export const updateRenter = (renterId, accessToken, updates) => __awaiter(void 0, void 0, void 0, function* () {
    const payload = Object.assign({}, updates);
    if (updates.add_note && updates.note) {
        payload.add_note = true;
        payload.note = updates.note;
    }
    const response = yield axios.patch(`${V2_API_URL}/renters/${renterId}`, payload, {
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
        },
    });
    return response.data;
});
// Delete a renter by ID
export const deleteRenter = (id, accessToken) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield axios.delete(`${V2_API_URL}/renters/${id}`, {
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
    });
    return response.data;
});
// Add Payment Method to a renter (if implemented)
export const addPaymentMethod = (id, accessToken, paymentMethodId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield axios.post(`${V2_API_URL}/renters/${id}/payment-method`, { payment_method_id: paymentMethodId }, {
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
    });
    return response.data;
});
export const getRentersByCustomerId = (customerId, accessToken) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    try {
        const response = yield axios.get(`${V2_API_URL}/renters`, {
            params: { customerId },
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`,
            },
        });
        return response.data;
    }
    catch (error) {
        console.error('Error fetching renters by customerId:', error);
        throw new Error(((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) || 'Failed to fetch renters.');
    }
});
/**
 * getVerificationFile
 * Retrieves a verification file as a Blob from the POS endpoint.
 *
 * If no accessToken is provided, it will attempt to retrieve it from localStorage.
 */
export const getVerificationFile = (fileId, accessToken) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    try {
        // If no token is provided, try to get it from localStorage
        if (!accessToken) {
            accessToken = localStorage.getItem('accessToken') || '';
            if (!accessToken) {
                throw new Error('Access token is missing.');
            }
        }
        const response = yield apiClient.get(`${V2_API_URL}/pos/get-verification-file`, {
            params: { fileId },
            headers: {
                'Authorization': `Bearer ${accessToken}`
            },
            responseType: 'blob',
        });
        if (response.status === 200) {
            return response.data;
        }
        else {
            throw new Error('Failed to retrieve file.');
        }
    }
    catch (error) {
        console.error('Error fetching verification file:', error);
        throw ((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) || 'Failed to fetch verification file.';
    }
});
/**
 * Retrieves all API keys (public keys) for the authenticated customer.
 * Expects an access token for authorization.
 */
export function getApiKeys(accessToken) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetch(`${V2_API_URL}/public-key`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
            },
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = yield response.json();
        return data;
    });
}
/**
 * Creates a new API key for the authenticated customer.
 * Expects an access token for authorization.
 */
export function createApiKey(accessToken) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetch(`${V2_API_URL}/public-key`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
            },
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return yield response.json();
    });
}
/**
 * Deletes the API key (public key) identified by keyId for the authenticated customer.
 * Expects an access token for authorization.
 */
export function deleteApiKey(keyId, accessToken) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetch(`${V2_API_URL}/public-key/${keyId}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
            },
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return yield response.json();
    });
}
